import { Flex, SimpleGrid, Text } from '@chakra-ui/react';
import React from 'react';

import {
  FACILITIES_TABLE_CONFIG,
  FacilitiesTableRow,
} from './facilitiesTableOptions';
import { colors } from '~/packages/common-frontend/colors';

// Fragments
type OverviewTileProps = { children: React.ReactNode; label: React.ReactNode };
const OverviewTile = ({ children, label }: OverviewTileProps) => (
  <Flex
    borderColor={colors.gray[100]}
    background={colors.background[50]}
    borderRadius="0.5rem"
    borderWidth="1px"
    flexDirection="column"
    flexGrow={1}
    flexShrink={0}
    gap="0.5rem"
    padding="1.5rem"
  >
    <Text color={colors.black[70]} fontSize="0.875rem" lineHeight="1.25rem">
      {label}
    </Text>
    <Text color={colors.black[95]} fontSize="1rem" fontWeight={500}>
      {children}
    </Text>
  </Flex>
);

// Exports
type FacilitiesOverviewTilesProps = {
  creditFacilityCount: number;
  totalsRow: FacilitiesTableRow;
};
export const FacilitiesOverviewTiles = ({
  creditFacilityCount,
  totalsRow,
}: FacilitiesOverviewTilesProps) => (
  <SimpleGrid columns={{ sm: 2, md: 4, lg: 4, xl: 4 }} gap="1.5rem">
    <OverviewTile label="Total Commitment">
      {FACILITIES_TABLE_CONFIG.commitmentAmount.parse(
        totalsRow.commitmentAmount,
      )}
    </OverviewTile>
    <OverviewTile label="Total Outstanding">
      {FACILITIES_TABLE_CONFIG.commitmentAmount.parse(
        totalsRow.loanOutstanding,
      )}
    </OverviewTile>
    <OverviewTile label="Total Unused Commitment">
      {FACILITIES_TABLE_CONFIG.commitmentAmount.parse(
        totalsRow.unusedCommitment,
      )}
    </OverviewTile>
    <OverviewTile label="Facilities">{creditFacilityCount}</OverviewTile>
  </SimpleGrid>
);
